module.exports = __webpack_public_path__ + "1003ce7af4933b1003244d8af9938ac1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-0.png
// module id = 1690
// module chunks = 0